import React from "react";
import { TableContentForCheckrollWeighReport } from '../../../Common/Table/tableContent';
import _ from "lodash"

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const headerLables = this.props.lables;
        const data = _.cloneDeep(this.props.data);
        const rowNames = this.props.rowNames;
        const details = this.props.weighDetails;
        const detailDeductions = this.props.detailDeductions;
        const employeeCount = this.props.employeeCount;
        const finalData = this.props.finalData;

        function roundNumbers(number) {
            return Math.round((number + Number.EPSILON) * 100) / 100
        }
        function totalRowCreate(array) {

            var rows = [];
            for (var i = 1; i < array.length; i++) {
                rows.push(<tr>
                    <td>{array[i].fieldName}</td>
                    <td style={{ textAlign: "right" }}>{array[i].actualAmount}</td>
                    <td style={{ textAlign: "right" }}>{array[i].grossAmount}</td>
                    <td style={{ textAlign: "right" }}>{array[i].netAmount}</td>
                    <td style={{ textAlign: "right" }}>{array[i].extraKg}</td>
                    <td style={{ textAlign: "right" }}>
                        <span className={array[i].gainLoss < 0 ? "badge badge-danger" : "badge badge-primary"}>
                            {array[i].gainLoss < 0 ? "Loss " : "Gain "}
                            {Math.abs(array[i].gainLoss)}
                        </span>
                    </td>
                </tr>);
            }
            return rows;
    
        }

        return (
            <div>
                <h3><center><u>Total Check Roll Weighment Summary Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division === undefined ? "All Divisions" : searchData.division}</div>
                    <div className="col"><b>Feild: </b> {searchData.feild === undefined ? "All Feilds" : searchData.feild}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="card">
                    <div className="card-header"><h6>Weigh Details</h6></div>
                    <div className="card-body">
                        <p className="d-inline pr-3"><b>Net Amount : </b> {details.gross} Kg</p>
                        <p className="d-inline pr-3"><b>Checkroll Amount : </b>{details.net} Kg</p>
                        <p className="d-inline pr-3"><b>Actual Amount : </b>{details.total} Kg</p>
                        <div className="d-inline"><b>Total {details.gainloss < 0 ? " Loss" : " Gain"} : </b><div className={details.gainloss < 0 ? "badge badge-danger" : "badge badge-primary"}
                            style={{ fontSize: "14px" }}>{Math.abs(details.gainloss)} Kg</div></div>
                        <br></br>
                    </div>
                </div>
                <div className="pl-2">
                    <div>
                        <table
                            id="summaryReportPdf">
                            <thead>
                                <tr style={{ fontSize: "12px" }}>
                                    <th style={{ fontSize: "12px" }}>EPF No</th>
                                    <th style={{ fontSize: "12px" }}>Reg No</th>
                                    <th style={{ fontSize: "12px" }}>First Name</th>
                                    <th style={{ fontSize: "12px" }}>Division</th>
                                    <th style={{ fontSize: "12px" }}>Field</th>
                                    <th style={{ fontSize: "12px" }}>Actual (Kg)</th>
                                    <th style={{ fontSize: "12px" }}>Net (Kg)</th>
                                    <th style={{ fontSize: "12px" }}>Checkroll (Kg)</th>
                                    <th style={{ fontSize: "12px" }}>Extra (Kg)</th>
                                    <th style={{ fontSize: "12px" }}>Total (Kg)</th>
                                    <th style={{ fontSize: "12px" }}>Gain/ Loss (Kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {finalData.map((row, index) => (
                                    <>
                                        <tr>
                                            <td rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.epfNo}</td>
                                            <td rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.registrationNumber}</td>
                                            <td rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.firstName}</td>
                                            <td rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.collectionPointName}</td>
                                            <td>{row.dataArray[0].fieldName}</td>
                                            <td style={{ textAlign: "right" }}>{row.dataArray[0].actualAmount}</td>
                                            <td style={{ textAlign: "right" }}>{row.dataArray[0].grossAmount}</td>
                                            <td style={{ textAlign: "right" }}>{row.dataArray[0].netAmount}</td>
                                            <td style={{ textAlign: "right" }}>{row.dataArray[0].extraKg}</td>
                                            <td style={{ textAlign: "right" }} rowspan={row.dataArray.length == 0 ? 1 : row.dataArray.length}>{row.total}</td>
                                            <td style={{ textAlign: "right" }}>
                                                <span className={row.dataArray[0].gainLoss < 0 ? "badge badge-danger" : "badge badge-primary"}>
                                                    {row.dataArray[0].gainLoss < 0 ? "Loss " : "Gain "}
                                                    {Math.abs(row.dataArray[0].gainLoss)}
                                                </span>
                                            </td>
                                        </tr>
                                        {totalRowCreate(row.dataArray)}
                                    </>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th style={{ textAlign: "left" }} colSpan="4">Total</th>
                                    <th style={{ textAlign: "left" }}>Employee Count {employeeCount}</th>
                                    <th style={{ textAlign: "right" }}>{details.total}</th>
                                    <th style={{ textAlign: "right" }}>{details.gross}</th>
                                    <th style={{ textAlign: "right" }}>{details.net}</th>
                                    <th style={{ textAlign: "right" }}>{details.extraKg}</th>
                                    <th style={{ textAlign: "right" }}>{details.allTot}</th>
                                    <th style={{ textAlign: "center" }}>
                                        <span className={details.gainloss < 0 ? "badge badge-danger" : "badge badge-primary"}>
                                            {details.gainloss < 0 ? "Loss " : "Gain "}
                                            {Math.abs(details.gainloss)}
                                        </span>
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}